import { useMutation } from '@tanstack/react-query';

import { prophetTypes } from '../types';

import { axios } from '@/libraries/axios';
import { MutationConfig, queryClient } from '@/libraries/react-query';

export const toggleProphetPageRefuses: prophetTypes.ToggleProphetPage = (data) => {
  const { pageId, isEnabled } = data;
  if (isEnabled) {
    return axios.post(`/prophet/pages/disable-refuses`, { pageId });
  }
  return axios.post(`/prophet/pages/enable-refuses`, { pageId });
};

type ToggleProphetPageRefusesOptions = {
  config?: MutationConfig<typeof toggleProphetPageRefuses>;
};

export function useToggleProphetPageRefuses({ config = {} }: ToggleProphetPageRefusesOptions = {}) {
  return useMutation({
    onSuccess: () => {
      queryClient.invalidateQueries(['prophet-pages']);
      queryClient.invalidateQueries(['prophet-page']);
      queryClient.invalidateQueries(['prophet-page-audit']);
    },
    ...config,
    mutationFn: toggleProphetPageRefuses,
  });
}
